var _rect, _g, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKeyInCircule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#D6E4FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#key-in-circule_svg__clip0_4414_78191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.472 19.555a5.833 5.833 0 019.342 6.736l9.056 9.056.005 2.61-5.064.007V35.5H30.35v-2.463h-2.463v-2.463l-1.678-1.678a5.833 5.833 0 01-6.736-9.342zm1.854 4.349a1.764 1.764 0 102.495-2.495 1.764 1.764 0 00-2.495 2.495z",
    fill: "#597EF7"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 52,
    height: 52,
    rx: 26,
    stroke: "#F0F5FF",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "key-in-circule_svg__clip0_4414_78191"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14 14)",
    d: "M0 0h28v28H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/key-in-circule.2ad75cb96d49bc8986e195a80fd025a4.svg";
export { SvgKeyInCircule as ReactComponent };